import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TruncatePipe } from '../shared/pipe/truncate.pipe';
import { MaterialModule } from './material.module';

@NgModule({
    imports: [ReactiveFormsModule,
        CommonModule,
        FormsModule,
        MaterialModule,
      ],
      declarations: [],
      providers: [DatePipe, TruncatePipe],
      exports: [
        ReactiveFormsModule,
        CommonModule,
        FormsModule,
        MaterialModule,
    ]
})
export class SharedModule { }
